import { ReactComponent as LeftArrow } from "../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/rightArrow.svg";
import { ReactComponent as Refresh } from "../../assets/icons/refresh.svg";
import { ReactComponent as SelectIcon } from "../../../common/assets/icons/selectIcon.svg";

import Input from "../../components/common/input";
import SelectBox from "../../components/common/selectBox";
import React, { useState } from "react";
import Button from "../../../common/components/button";
import Excel from "../../components/common/excel";
import OBTable from "./-components/OBTable";
import OBDetail from "./-components/OBDetail/OBDetail";
import { useGetOtherBranchList } from "../../../common/hooks/console/otherBranch/useGetOtherBranch";
import { useGetOtherBranchCount } from "../../../common/hooks/console/otherBranch/useGetOtherBranchCount";
import Spinner from "../../../common/components/spinner";
import { useNavigate, useSearchParams } from "react-router-dom";

const OtherBranch = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const customerIdxParam = searchParams.get("customerIdx");
    const navigate = useNavigate();

    const [isRefreshing, setIsRefreshing] = useState(false);
    const [excelClick, setExcelClick] = useState(false);
    const [pageSize, setPageSize] = useState<number>(20);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [field, setField] = useState<string>("customer_name");
    const [direction, setDirection] = useState<"ASC" | "DESC">("ASC");
    const [customerIdx, setCustomerIdx] = useState<number>(Number(customerIdxParam) || 0);
    const [customerName, setCustomerName] = useState<string>("");
    const [status, setStatus] = useState<number>(0);

    const {
        data: listData,
        refetch: refetchList,
        isLoading: isListLoading,
    } = useGetOtherBranchList({
        page: currentPage,
        limit: pageSize,
        searchtxt: searchTxt,
        field: field,
        direction: direction,
        status: status,
    });

    const { data: countData, refetch: refetchCount } = useGetOtherBranchCount();
    const handleRefresh = async () => {
        setIsRefreshing(true);
        const startTime = Date.now();
        await Promise.all([refetchList(), refetchCount()]);

        const elapsedTime = Date.now() - startTime;
        const remainingTime = Math.max(100 - elapsedTime, 0);

        setTimeout(() => {
            setIsRefreshing(false);
        }, remainingTime);
    };
    const handleSort = (newField: string) => {
        setField(prevField => {
            if (prevField === newField) {
                setDirection(prevDirection => (prevDirection === "ASC" ? "DESC" : "ASC"));
                return prevField;
            } else {
                setDirection("DESC");
                return newField;
            }
        });
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setInputValue(page.toString());
    };

    const handlePageSizeChange = (value: string) => {
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (listData?.last_page || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        handlePageChange(pageNumber);
    };

    return (
        <div className="flex h-dvh">
            {(isListLoading || isRefreshing) && <Spinner />}
            {customerIdxParam ? (
                <OBDetail
                    customer={customerName}
                    customerIdx={customerIdx}
                    showOBDetail={() => {
                        setSearchParams({});
                        navigate("/console/other-branch");
                    }}
                />
            ) : (
                <div className="h-full flex w-full flex-col overflow-hidden">
                    {/* Header */}
                    <div className="flex justify-between p-3 items-center border-b border-gray4">
                        <div className=" flex items-center gap-5">
                            <p className="text-2xl">타지점정산</p>
                            <div className="flex gap-3 items-center">
                                <div className={`${status === 1 ? "font-bold" : ""} flex text-sm items-center gap-1`}>
                                    <p>미정산 타지점</p>
                                    <button
                                        className="font-bold text-error underline"
                                        onClick={() => {
                                            status === 1 && setStatus(0);
                                            status === 0 && setStatus(1);
                                            setCurrentPage(1);
                                            setInputValue("1");
                                        }}
                                    >
                                        {countData?.pending_customer_count.toLocaleString()}
                                    </button>
                                    <p>건</p>
                                </div>
                                <div className="flex items-center gap-1">
                                    <p className="text-xs">총 미정산금액</p>
                                    <p className="text-sm font-bold text-error">{countData?.total_pending_amount.toLocaleString()}원</p>
                                </div>
                                <div className="flex items-center gap-1">
                                    <p className="text-xs">이번 달 발주금액</p>
                                    <p className="text-sm font-bold text-primary2">{countData?.monthly_order_amount.toLocaleString()}원</p>
                                </div>
                                <div className="flex items-center gap-1">
                                    <p className="text-xs">이번 달 발주건수</p>
                                    <p className="text-sm font-bold text-primary2">{countData?.monthly_order_count.toLocaleString()}건</p>
                                </div>
                                <div className="flex items-center gap-1">
                                    <p className="text-xs">이번 달 정산금액</p>
                                    <p className="text-sm font-bold text-primary2">
                                        {countData?.monthly_payment_amount.toLocaleString()}원
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={() => currentPage && currentPage > 1 && handlePageChange(currentPage - 1)}>
                                <LeftArrow />
                            </button>
                            <Input
                                inputClassName="text-center"
                                className="w-20 text-center outline-0 text-sm flex"
                                value={inputValue}
                                onChange={e => handlePageInput(e.target.value)}
                            />
                            <p className="text-gray3">/ {listData?.last_page}</p>
                            <button
                                onClick={() => currentPage && currentPage < (listData?.last_page || 1) && handlePageChange(currentPage + 1)}
                            >
                                <RightArrow />
                            </button>
                        </div>
                    </div>
                    {/* Title */}
                    <div className="flex justify-between p-3 items-center border-b border-gray4">
                        <div className="flex gap-1 items-center ">
                            <p className="text-xs">총</p>
                            <button className="text-sm font-bold text-primary2">{listData?.total_count.toLocaleString()}</button>
                        </div>
                        <div className="flex gap-2 items-center">
                            <Refresh className="cursor-pointer" onClick={handleRefresh} />
                            <SelectBox
                                status="none"
                                className="w-[100px]"
                                options={[
                                    { value: "20", label: "20건씩" },
                                    { value: "50", label: "50건씩" },
                                    { value: "100", label: "100건씩" },
                                ]}
                                value={pageSize.toString()}
                                onChange={handlePageSizeChange}
                            />
                            <Input
                                value={searchTxt}
                                onChange={e => setSearchTxt(e.target.value)}
                                placeholder="검색"
                                status="none"
                                className="w-[240px] h-8"
                            />
                            
                        </div>
                    </div>
                    <div className="overflow-hidden">
                        <OBTable
                            onSort={handleSort}
                            data={listData?.data_list}
                            showOBDetail={(customerIdx, customerName) => {
                                setCustomerIdx(customerIdx);
                                setCustomerName(customerName);
                                setSearchParams({ customerIdx: customerIdx.toString() });
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default OtherBranch;
